/* eslint-disable @typescript-eslint/consistent-type-assertions */

import { type MachineImplementationsFrom, setup } from 'xstate5';

import {
  Actions,
  type Context,
  type Event,
  generateInitialContext,
} from './setup';

// ─── Model ───────────────────────────────────────────────────────────────────

const model = setup({
  types: {
    context: {} as Context,
    events: {} as Event,
  },
  actions: {
    toggleRestrictions: Actions.toggleRestrictions,
    resetPendingChanges: Actions.resetPendingChanges,
    confirmPendingChanges: Actions.confirmPendingChanges,
    resetRestrictions: Actions.resetRestrictions,

    // ─── External Actions ────────────────────────────────────────────────

    onStart() {},
    onConfirm() {},
  },
});

// ─── Machine ─────────────────────────────────────────────────────────────────

export const dietaryPreferencesMachine = model.createMachine({
  id: 'dietaryPreferencesMachine',
  context: generateInitialContext(),
  initial: 'idle',
  states: {
    idle: {
      on: {
        START: {
          target: 'active',
          actions: 'onStart',
        },
      },
    },
    active: {
      on: {
        TOGGLE_RESTRICTION: {
          actions: 'toggleRestrictions',
        },
        CANCEL: {
          target: 'idle',
          actions: 'resetPendingChanges',
        },
        CONFIRM: {
          actions: ['confirmPendingChanges', 'onConfirm'],
          target: 'idle',
        },
      },
    },
  },
  on: {
    RESET: {
      actions: 'resetRestrictions',
    },
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

export type DietaryPreferencesMachineImplementations =
  MachineImplementationsFrom<typeof dietaryPreferencesMachine>;
